import React, {useContext} from 'react';

import {SetupGuideContext} from 'common/onboarding/immersive-onboarding/types';

import {InstallJavascriptSDK} from './InstallJavascriptSDK';
import {AlternateSDKs} from './AlternateSDKs';

export const ConnectSDK = () => {
  const {selectAltSDK} = useContext(SetupGuideContext);

  return selectAltSDK ? <AlternateSDKs /> : <InstallJavascriptSDK />;
};
